import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BusinesLogicService } from '../../services/business-logic.service';
import { DataService } from '../../services/data.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { SocketService } from "../../services/socket.service";
import { Subscription } from 'rxjs/Subscription';
import { TestScheduler, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-deskstatus',
  templateUrl: './deskstatus.component.html',
  styleUrls: ['./deskstatus.component.css']
})
export class DeskStatusComponent implements OnInit {

  @Output() websocketError: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() withButton: boolean = false;

  public desks: any = [];
  public totalInOffice: number = 0;

  private destroy$ = new Subject();

  constructor(private _blogic: BusinesLogicService,
    private _modal: ModalHelper) {
  }

  ngOnInit() {
    this.getDeskStatus();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Get desk status */
  public getDeskStatus(): void {
    this._blogic.getDeskInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
         this.desks = response;
        }
      );
  }

  /* Open status modal */
  public openStatusModal(): void {
    this._blogic.getDeskInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
         this.desks = response;
         this._modal.show("deskStatusModal");
        }
      );
  }
}
